import React from 'react';
import { motion } from 'framer-motion';
export const ClosingSection = () => {
  return <section className="py-24 bg-white border-t border-neutral-200" data-id="element-53">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-54">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-55">
          <h2 className="text-3xl sm:text-4xl font-bold text-neutral-900 mb-12" data-id="element-56">
            Una última cosa antes de que te vayas.
          </h2>

          <p className="text-xl text-neutral-700 mb-12" data-id="element-57">
            Dentro de 30 días vas a estar en uno de estos dos lugares.
          </p>

          <div className="grid sm:grid-cols-2 gap-8 mb-16 text-left" data-id="element-58">
            <div className="bg-cream p-8 rounded-xl border border-neutral-200 shadow-sm" data-id="element-59">
              <h3 className="text-xl font-bold text-neutral-800 mb-4 flex items-center gap-2" data-id="element-60">
                😔 LUGAR A — Sin el sistema:
              </h3>
              <p className="text-neutral-600 leading-relaxed" data-id="element-61">
                Exactamente igual que hoy. El WhatsApp en silencio. Los
                presupuestos sin respuesta. Pensando si bajar los precios.
                Esperando que el mercado se recupere solo. Trabajando más horas
                por menos plata.
              </p>
            </div>

            <div className="bg-brand-600 p-8 rounded-xl shadow-md" data-id="element-62">
              <h3 className="text-xl font-bold text-white mb-4 flex items-center gap-2" data-id="element-63">
                💪 LUGAR B — Con CAJA DE COBRO:
              </h3>
              <p className="text-brand-50 leading-relaxed" data-id="element-64">
                Con un sistema funcionando. Con conversaciones abiertas en tu
                WhatsApp. Con al menos 1 cliente nuevo cerrado. Con la claridad
                de saber qué decir en cada situación. Con los scripts listos
                para el próximo "no tengo plata". Con un plan para el mes que
                viene y el que sigue.
              </p>
            </div>
          </div>

          <div className="space-y-4 text-xl font-medium text-neutral-700 mb-12" data-id="element-65">
            <p data-id="element-66">La diferencia entre esos dos lugares es una decisión.</p>
            <p data-id="element-67">Una decisión que tomás ahora.</p>
            <div className="py-6" data-id="element-68">
              <p data-id="element-69">No es el mercado el que decide tu próximo mes.</p>
              <p data-id="element-70">No es la crisis.</p>
              <p data-id="element-71">No es la inflación.</p>
              <p className="text-3xl font-bold text-neutral-900 mt-4" data-id="element-72">
                Sos vos.
              </p>
            </div>
          </div>

          <div className="max-w-xl mx-auto" data-id="element-73">
            <a href="https://tienda-1-10001.myshopify.com/checkouts/cn/hWNAQr3NwJsa0SuPUCDhl49i/es-ar?_r=AQAB71_6lH8s5n5_3gT2kf8ZrN9yZsImNxSKOxJ4M95T_VM&preview_theme_id=144578674765" target="_blank" rel="noopener noreferrer" className="group relative flex w-full items-center justify-center gap-2 overflow-hidden rounded-xl bg-brand-600 px-8 py-6 font-sans text-lg sm:text-xl font-bold text-white shadow-lg transition-all hover:bg-brand-700 hover:shadow-xl hover:scale-[1.02] active:scale-[0.98] mb-6" data-id="element-74">
              <span className="relative z-10 flex items-center gap-2" data-id="element-75">
                👇 QUIERO ESTAR EN EL LUGAR B — $19.990 ARS
              </span>
              <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/10 to-transparent transition-transform duration-1000 group-hover:translate-x-full" data-id="element-76" />
            </a>

            <p className="text-sm text-neutral-500 mb-12" data-id="element-77">
              Solo $19.990 ARS · Acceso Inmediato · Garantía 7 días
              <br data-id="element-78" />
              Pago 100% seguro con Mercado Pago
            </p>
          </div>

          <div className="border-t border-neutral-200 pt-12 text-sm text-neutral-500" data-id="element-79">
            <p className="mb-4" data-id="element-80">
              ¿Tenés alguna pregunta antes de comprar? Escribinos al
              [WhatsApp/mail] y respondemos en menos de 2 horas.
            </p>
            <p className="mb-2" data-id="element-81">
              © 2026 CAJA DE COBRO · Todos los derechos reservados
            </p>
            <p className="max-w-xl mx-auto" data-id="element-82">
              Este producto es un material digital en formato PDF de descarga
              inmediata. Los resultados dependen de la aplicación individual del
              sistema.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
};